import { render } from "./insure-team-worker.vue?vue&type=template&id=aea08c40&scoped=true&ts=true"
import script from "./insure-team-worker.vue?vue&type=script&lang=ts"
export * from "./insure-team-worker.vue?vue&type=script&lang=ts"

import "./insure-team-worker.vue?vue&type=style&index=0&id=aea08c40&lang=stylus&scoped=true"

import exportComponent from "D:\\Repository\\Zidan\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aea08c40"]])

export default __exports__